/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Create Geofence Icon component.
 */
export const CreateGeoFenceIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.3999 2.36463C17.1116 3.3592 18.4935 7.2309 17.7279 10.0888C17.5461 10.7671 17.1074 11.6151 16.4601 12.5526C15.8182 13.4822 14.9938 14.4664 14.076 15.413C12.3946 17.1472 10.4443 18.7074 8.78763 19.5777C7.78817 17.9957 6.87915 15.6691 6.29013 13.3267C5.96864 12.0482 5.7477 10.7838 5.65659 9.65787C5.56472 8.52224 5.60882 7.5685 5.79056 6.89023C6.55644 4.03247 9.68825 1.37033 13.3999 2.36463Z' stroke={iconColor} strokeWidth='1.25' />
      <circle cx='11.654' cy='8.88068' r='1.70102' transform='rotate(15 11.654 8.88068)' fill={iconColor} />
      <path d='M11.8008 8.33301L8.87666 19.246' stroke={iconColor} strokeWidth='1.25' />
      <path d='M18.3682 15.7319V23.9999' stroke={iconColor} strokeWidth='1.25' />
      <path d='M14.2344 19.8662L22.5024 19.8662' stroke={iconColor} strokeWidth='1.25' />
    </svg>
  );
};

export default CreateGeoFenceIcon;
